import { AlertTriangle, Check, Circle, Clock, HelpCircle, Loader2, type LucideIcon } from "lucide-react";

export type StatusChipState = "queued" | "running" | "done" | "stale" | "error" | "not-checked";

const STATUS_CHIP_META: Record<StatusChipState, { label: string; Icon: LucideIcon }> = {
  queued: { label: "Queued", Icon: Circle },
  running: { label: "Running", Icon: Loader2 },
  done: { label: "Done", Icon: Check },
  stale: { label: "Stale", Icon: Clock },
  error: { label: "Error", Icon: AlertTriangle },
  "not-checked": { label: "Not checked", Icon: HelpCircle },
};

export function StatusChip({
  state,
  label,
  title,
  size = "md",
}: {
  state: StatusChipState;
  label?: string;
  title?: string;
  size?: "sm" | "md";
}) {
  const meta = STATUS_CHIP_META[state];
  const Icon = meta.Icon;
  const chipLabel = label ?? meta.label;
  return (
    <span
      className={`status-chip status-chip-${state} status-chip-${size}`}
      title={title}
      aria-label={title ?? chipLabel}
    >
      <Icon
        aria-hidden="true"
        className={state === "running" ? "status-chip-icon status-chip-icon-spin" : "status-chip-icon"}
      />
      <span>{chipLabel}</span>
    </span>
  );
}
